"use client"
import Title from "../Title/Title"

// Import swiper data
import { SWIPERDATA } from "./swiperdata"
import "aos/dist/aos.css"
import Swiper from "../Swiper/Swiper"

function SwiperSection() {
  return (
    <div
      className="flex flex-col py-16 ps-6 xl:ps-16 3xl:ps-24 bg-[--color-light] w-full"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="400"
    >
      <div className="flex flex-row justify-between w-full mb-8 xl:mb-16">
        <div className="flex">
          <Title
            type="h2"
            className="uppercase text-[24px] xl:text-[60px]"
            orange="services"
            title=""
          />
        </div>
        <div className="flex items-center gap-2 pe-[24px]">
          {/* Swiper navigation goes here */}
          <button
            className="swiper-button-prev-custom bg-[--color-gray] hover:bg-[--color-danger] flex xl:h-[62px] xl:w-[62px] items-center justify-center justify-self-end svg-wrapper transition-bg group-hover:bg-danger-gradient"
            aria-label="Previous"
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </button>
          <button
            className="swiper-button-next-custom bg-[--color-gray] hover:bg-[--color-danger] flex xl:h-[62px] xl:w-[62px] items-center justify-center justify-self-end svg-wrapper transition-bg group-hover:bg-danger-gradient"
            aria-label="Next"
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
            </svg>
          </button>
        </div>
      </div>
      <div className="flex w-full gap-4 xl:gap-9">
        <Swiper
          data={SWIPERDATA.services}
          navigation={{
            prevEl: ".swiper-button-prev-custom",
            nextEl: ".swiper-button-next-custom",
          }}
          swiperOptions={{
            spaceBetween: 24,
            slidesPerView: 2,
            speed: 6000,
            breakpoints: {
              0: { slidesPerView: 1.2 },
              1024: { slidesPerView: 1.2 },
              1440: { slidesPerView: 2.2 },
              1921: { slidesPerView: 2.2 },
            },
          }}
          type="about-services"
          // Removed className as it is not supported by SwiperProps
        />
      </div>
    </div>
  )
}

export default SwiperSection
